/**
 * Portal Hint Aggregation
 *
 * Aggregated arrays of hint configs per portal. Also provides a combined
 * array of all hints across portals for global lookups.
 */

import { adminPortalHints } from './admin-portal-hints';
import { casesEntitiesHints } from './cases-entities-hints';
import { consumerPortalHints } from './consumer-portal-hints';
import { dashboardHints } from './dashboard-hints';
import type { HintConfig } from './hint-config.types';
import { settingsPipelineHints } from './settings-pipeline-hints';

export const allBusinessPortalHints: HintConfig[] = [
  ...dashboardHints,
  ...casesEntitiesHints,
  ...settingsPipelineHints,
];

export const allConsumerPortalHints: HintConfig[] = [...consumerPortalHints];

export const allAdminPortalHints: HintConfig[] = [...adminPortalHints];

/** All hints across all portals */
export const allPortalHints: HintConfig[] = [
  ...allBusinessPortalHints,
  ...allConsumerPortalHints,
  ...allAdminPortalHints,
];
